import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const TOKEN_STORAGE_KEY = "aseka_admin_token";

const tokenStorage = {
  get: () => sessionStorage.getItem(TOKEN_STORAGE_KEY),
  set: (v) => sessionStorage.setItem(TOKEN_STORAGE_KEY, v),
  clear: () => sessionStorage.removeItem(TOKEN_STORAGE_KEY),
};

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export { tokenStorage };

export const resolveAssetUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
